<template>
  <component :is="footerType"></component>
</template>

<script>
import FooterDesktop from './FooterDesktop';
import FooterMobile from './FooterMobile';

export default {
  components: {
    'footer-desktop': FooterDesktop,
    'footer-mobile': FooterMobile,
  },
  data() {
    return {
      footerType: 'footer-desktop',
    };
  },
  methods: {
    setFooterType() {
      this.footerType = (window.innerWidth >= 1023) ? 'footer-desktop' : 'footer-mobile';
    },
  },
  mounted() {
    this.setFooterType();
    window.addEventListener('resize', this.setFooterType);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setFooterType);
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Footer/index.vue